import { speakKarenNarration } from "./karenNarration";

// Read all supplied text; never silently truncate a lesson or book excerpt.
export function readingChunks(text, limit = 900) {
  const clean = String(text || "").replace(/\s+/g, " ").trim();
  if (!clean) return [];
  const sentences = clean.split(/(?<=[.!?])\s+/);
  const chunks = [];
  let current = "";
  const flush = () => { if (current) chunks.push(current); current = ""; };
  for (const sentence of sentences) {
    if (current && current.length + sentence.length + 1 > limit) flush();
    if (sentence.length <= limit) { current = current ? `${current} ${sentence}` : sentence; continue; }
    for (const word of sentence.split(/\s+/)) {
      if (current && current.length + word.length + 1 > limit) flush();
      current = current ? `${current} ${word}` : word;
    }
  }
  flush();
  return chunks;
}

let activeReader = null;
export function createKarenReader(text, { speak = speakKarenNarration, onState = () => {} } = {}) {
  const chunks = readingChunks(text);
  let index = 0, running = false, paused = false, disposed = false, generation = 0;
  let controller;
  const notify = state => { if (!disposed) onState(state); };
  const reader = {
    async play() {
      if (disposed || !chunks.length) return;
      paused = false;
      if (running) { notify("playing"); return; }
      if (activeReader && activeReader !== reader) activeReader.stop();
      activeReader = reader;
      if (index >= chunks.length) index = 0;
      const run = ++generation;
      running = true; notify("playing");
      controller = new AbortController();
      try {
        while (index < chunks.length && !paused && !controller.signal.aborted) {
          const spoken = await speak(chunks[index], { signal: controller.signal });
          if (run !== generation || disposed) return;
          if (!spoken) { notify("error"); return; }
          index += 1;
        }
        if (run !== generation || disposed) return;
        notify(index >= chunks.length ? "finished" : "paused");
      } catch {
        if (run === generation) notify("error");
      } finally {
        if (run === generation) { running = false; if (activeReader === reader) activeReader = null; }
      }
    },
    pause() { paused = true; notify(running ? "pausing" : "paused"); },
    stop() {
      generation += 1; controller?.abort(); running = false; paused = false; index = 0;
      if (activeReader === reader) activeReader = null;
      notify("idle");
    },
    dispose() { disposed = true; reader.stop(); },
  };
  return reader;
}
